import { z } from 'zod';
import { CuidSchema } from './crm.schemas.js';
import { FEEDBACK_ENTITIES, MAX_FEEDBACK_CHARS } from './feedback.js';

/**
 * مخططات التغذية الراجعة.
 */

export const FeedbackListQuerySchema = z.object({
  entity: z.enum(FEEDBACK_ENTITIES),
  entityId: CuidSchema,
});
export type FeedbackListQuery = z.infer<typeof FeedbackListQuerySchema>;

/**
 * إنشاء تغذية راجعة.
 *
 * النصّ أو الصوت — أحدهما على الأقل. تعليقٌ فارغ ليس رأيًا، وسطرٌ فارغ في
 * سجل يقرؤه فريق يشغل مكانًا ولا يقول شيئًا.
 */
export const CreateFeedbackSchema = z
  .object({
    entity: z.enum(FEEDBACK_ENTITIES),
    entityId: CuidSchema,
    body: z
      .string()
      .trim()
      .max(MAX_FEEDBACK_CHARS, `النصّ أطول من ${MAX_FEEDBACK_CHARS} حرفًا.`)
      .optional(),
    /** معرّف المرفق الصوتي — يُرفع أولًا ثم يُشار إليه. */
    attachmentId: CuidSchema.nullable().optional(),
    /**
     * الردّ على تعليق.
     *
     * مستوى واحد لا شجرة: الردّ على ردٍّ على ردّ يُنتج خيطًا لا يُقرأ في
     * شاشة عرضها ثمانون حرفًا. والردود كلها تحت أصلها.
     */
    parentId: CuidSchema.nullable().optional(),
  })
  .refine((v) => (v.body && v.body.length > 0) || v.attachmentId, {
    message: 'اكتب ملاحظة أو سجّل صوتًا.',
    path: ['body'],
  });
export type CreateFeedbackInput = z.infer<typeof CreateFeedbackSchema>;

export const UpdateFeedbackSchema = z.object({
  body: z.string().trim().min(1, 'النصّ مطلوب.').max(MAX_FEEDBACK_CHARS),
});
export type UpdateFeedbackInput = z.infer<typeof UpdateFeedbackSchema>;
